import {FC, useEffect, useState} from 'react'

const OLIVE = '#a3a242'
const DANGER = '#d7383c'

type MarkUnavailableModalProps = {
  interpreterName: string
  onClose: () => void
  onConfirm: () => Promise<void>
}

const MarkUnavailableModal: FC<MarkUnavailableModalProps> = ({
  interpreterName,
  onClose,
  onConfirm,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const handleConfirm = async () => {
    setIsSubmitting(true)
    try {
      await onConfirm()
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <div
        className='modal fade show d-block'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
        onClick={onClose}
      >
        <div
          className='modal-dialog modal-dialog-centered'
          style={{maxWidth: '480px'}}
          onClick={(e) => e.stopPropagation()}
        >
          <div className='modal-content rounded overflow-hidden'>
            <div className='modal-header border-0 pb-0 px-6 pt-5'>
              <div className='d-flex align-items-center gap-3 flex-grow-1'>
                <div
                  className='d-flex align-items-center justify-content-center rounded'
                  style={{
                    width: '40px',
                    height: '40px',
                    backgroundColor: 'rgba(215,56,60,0.12)',
                    color: DANGER,
                    fontSize: '18px',
                  }}
                >
                  <i className='bi bi-exclamation-triangle-fill'></i>
                </div>
                <h3 className='modal-title fw-bold mb-0 fs-3 text-gray-900'>Mark Unavailable</h3>
              </div>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-active-light-primary'
                onClick={onClose}
                disabled={isSubmitting}
              >
                <i className='bi bi-x-lg'></i>
              </button>
            </div>

            <div className='modal-body px-6 pt-4 pb-2'>
              <p className='text-gray-700 mb-0 fs-6'>
                Are you sure you want to mark <span className='fw-bold'>{interpreterName}</span>{' '}
                unavailable for this appointment?
              </p>
            </div>

            <div className='modal-footer border-0 px-6 pb-5 pt-4 gap-2'>
              <button
                type='button'
                className='btn btn-light fw-semibold'
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type='button'
                className='btn fw-semibold text-white'
                style={{backgroundColor: OLIVE, borderColor: OLIVE}}
                onClick={handleConfirm}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Marking...' : 'Mark Unavailable'}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export default MarkUnavailableModal
